import CustomerSituationPOS from "../components/Comptoire/CustomerSituationPOS";
import React from "react";
import { Navigate } from "react-router-dom";

import {
  LOGIN_PAGE,
  PRODUCTS_PAGE,
  DASHBOARD_PAGE,
  STOCK_PAGE,
  BARCODE_PAGE,
  SALES_PAGE,
  SALES_HISTORY_PAGE,
  REFUND_PAGE,
  REFUNDS_HISTORY_PAGE,
  PROFILE_PAGE,
  INVOICE_PAGE,
  INVENTORY_PAGE,
  CLIENT_PAGE,
  COMPANY_PAGE,
  DEVIS_PAGE,
  BUYS_PAGE,
  BUYS_HISTORY_PAGE,
  DELIVERY_NOTE_PAGE,
  PURCHASE_PAGE,
  PURCHASE_FORM_PAGE,
  PURCHASE_ORDERS_PAGE,
  RECEPTION_PAGE,
  RECEPTION_FORM_PAGE,
  SUPPLIER_INVOICE_PAGE,
  SUPPLIER_PAYMENTS_PAGE,
  CUSTOMER_PAYMENTS_PAGE,
  SUPPLIER_PAGE,
  ENTREPOT_PAGE,
  CLIENT_FORM_PAGE,
  CATEGORY_PAGE,
  UM_PAGE,
  PRODUCTS_FORM_PAGE,
  COMMANDE_PAGE,
  CHECK_MANAGEMENT_PAGE,
  SALES_REPORT_PAGE,
  REGLEMENTS_PAGE,
  REGLEMENTS_REPORT_PAGE,
  LOT_PAGE,
  MOUVEMENT_STOCK_PAGE,
  NEW_INVOICE_PAGE,
  CUSTOMER_RETURNS_PAGE,
  CUSTOMER_RETURN_FORM_PAGE,
  CUSTOMER_RETURN_DETAIL_PAGE,
  RELEVE_COMPTE_PAGE,
  BALANCE_COMPTABLE_PAGE,
  GRAND_LIVRE_PAGE,
  SYNTHESE_COMPTABLE_PAGE,
  MODULES_PAGE,
  DASHBOARD_MODULE_PAGE,
  DASHBOARD_INDICATORS_PAGE,
  INVENTORY_MODULE_PAGE,
  SALES_MODULE_PAGE,
  PURCHASES_MODULE_PAGE,
  FINANCE_MODULE_PAGE,
  ACCOUNTING_MODULE_PAGE,
  REPORTS_MODULE_PAGE,
  SETTINGS_MODULE_PAGE,
  WOOCOMMERCE_MODULE_PAGE,
  ZAKAT_MODULE_PAGE,
  CLIENT_EDIT_PAGE,
  REGLEMENT_FORM_PAGE,
  POS_PAGE,
  CBL_PAGE,
  PAY_PAGE,
  PAY_FORM_NEW,
  PAY_FORM_EDIT,
  RETOUR_PAGE,
  CPMT_STOCK_PAGE,
  CPMT_PRODUCTS_PAGE,
  CPMT_PRODUCTS_FORM_NEW,
  CPMT_PRODUCTS_FORM_EDIT,
  CPMT_RECEPTION_PAGE,
  CPMT_PROMOTION_PAGE,
  CPMT_LABELS_PAGE,
  CPMT_CUSTOMER_SITUATION_PAGE,
  POS_MODULE_PAGE,
  SHIFT_MODULE_PAGE,
  SHIFT_DETAIL_PAGE,
  PROMOTION_MODULE_PAGE,
  RETOUR_FORM_NEW,
  RETOUR_FORM_EDIT,
} from "./routeConstants";
import SaleForm from "../components/Sales/SalesForm";
import LoginForm from "../components/Auth/Login";
import ProductList from "../components/Products/ProductList";
import Dashboard from "../components/Dashboard";
import StockPage from "../components/Stock";
import { ROLE_ADMIN, ROLE_AGENT, ROLE_CAISSE, ROLE_MANAGER, ROLE_SUPER_ADMIN } from "../helpers/constants";
import BarcodePage from "../components/Stock/BarcodePage";
import Landing from "../components/landing/Landing";
import ProfilePage from "../components/Profil/ProfilePage";
import InvoiceList from "../components/Factures/InvoiceListe/InvoiceList";
import InventoryListPage from "../components/Inventory/InventoryListPage";
import ClientList from "../components/Client/ClientList";
import DevisList from "../components/Devis/DevisList";
import DeliveryList from "../components/BonLivraison/DeliveryListe";
import BuyForm from "../components/Purchase/BuysForm";
import BuysReport from "../components/Purchase/BuysReport";
import PurchasePage from "../components/Purchase/PurchasePage";
import PurchaseForm from "../components/Purchase/PurchaseForm";
import ReceptionPage from "../components/Reception/ReceptionPage";
import ReceiptNoteNew from "../components/Reception/ReceiptNoteNew";
import SupplierInvoiceList from "../components/SupplierInvoice/SupplierInvoiceList";
import SupplierPaimentsList from "../components/Payments/SupplierPaimentsList";
import ClientPaimentsList from "../components/Payments/ClientPaimentsList";
import SupplierInvoiceSummary from "../components/SupplierInvoice/SupplierInvoiceSummary";
import EntrepotPage from "../components/Entrepot/EntrepotPage";
import ClientForm from "../components/Client/ClientForm";
import ProductForm from "../components/Products/ProductForm";
import CategorieList from "../components/Products/CategorieList";
import UnitesList from "../components/Products/UnitesList";
import BonCommandeList from "../components/Devis/BonCommandeList";
import DashboardEncaissements from "../components/Dashboard/DashboardEncaissements";
import VentesStatistiques from "../components/Dashboard/VentesStatistiques";
import NewInvoicePage from "../components/Factures/NewInvoicePage";
import CustomerReturnsList from "../components/RetourClient/CustomerReturnsList";
import CustomerReturnDetail from "../components/RetourClient/CustomerReturnDetail";
import { ReleveCompte, BalanceComptable, GrandLivre, SyntheseComptable } from "../components/Comptabilite";

// Module Components
import ModuleSelector from "../components/ModuleSelector/ModuleSelector";
import DashboardModule from "../components/ModuleWrappers/DashboardModule";
import InventoryModule from "../components/ModuleWrappers/InventoryModule";
import SalesModule from "../components/ModuleWrappers/SalesModule";
import PurchasesModule from "../components/ModuleWrappers/PurchasesModule";
import FinanceModule from "../components/ModuleWrappers/FinanceModule";
import AccountingModule from "../components/ModuleWrappers/AccountingModule";
import ReportsModule from "../components/ModuleWrappers/ReportsModule";
import SettingsModule from "../components/ModuleWrappers/SettingsModule";
import WooCommerceModule from "../components/ModuleWrappers/WooCommerceModule";
import ZakatModule from "../components/ModuleWrappers/ZakatModule";
import ReglementsList from "../components/ReglementClient/ReglementsList";
import ReglementReport from "../components/ReglementClient/ReglementReport";
import POSPage from "../components/Comptoire/POSPage";
import CustomerDisplay from "../components/Comptoire/CustomerDisplay";
import BonComptoireList from "../components/Comptoire/BonComptoireList";
import AvanceClientList from "../components/Comptoire/AvanceClientList";
import ReglementForm from "../components/Comptoire/ReglementForm";
import RetourClientList from "../components/Comptoire/CustomerReturnsList";
import CStockPage from "../components/Comptoire/Stocks";
import CProductList from "../components/Comptoire/ProductList";
import CFormulaireArticle from "../components/Comptoire/ProductForm";
import CReceptionPage from "../components/Comptoire/ReceptionPage";
import POSModule from "../components/ModuleWrappers/POSModule";
import ShiftModule from "../components/ModuleWrappers/ShiftsModule";
import PromotionModule from "../components/ModuleWrappers/PromotionModule";
import ShiftDetails from "../components/Shifts/ShiftDetails";
import CustomerReturnForm from "../components/Comptoire/CustomerReturnForm";
import PromotionListPOS from "../components/Comptoire/PromotionListPOS";
import LabelGenerationPOS from "../components/Comptoire/LabelGenerationPOS";

const authProtectedRoutes = [
  // Default redirect to modules
  {
    path: "/",
    component: <Navigate to="/modules" replace />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER, ROLE_SUPER_ADMIN],
  },
  {
    path: POS_PAGE,
    component: <POSPage />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },
  {
    path: "/customer-display",
    component: <CustomerDisplay />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },
  {
    path: CBL_PAGE,
    component: <BonComptoireList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },

  {
    path: CPMT_STOCK_PAGE,
    component: <CStockPage />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },

  {
    path: CPMT_RECEPTION_PAGE,
    component: <CReceptionPage />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },
  {
    path: CPMT_PROMOTION_PAGE,
    component: <PromotionListPOS />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },
  {
    path: CPMT_CUSTOMER_SITUATION_PAGE,
    component: <CustomerSituationPOS />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },
  {
    path: CPMT_LABELS_PAGE,
    component: <LabelGenerationPOS />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },

  {
    path: CPMT_PRODUCTS_PAGE,
    component: <CProductList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },

  {
    path: PAY_PAGE,
    component: <AvanceClientList />,
    roles: [ROLE_CAISSE,ROLE_ADMIN],
  },
  {
    path: PAY_FORM_NEW,
    component: <ReglementForm />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },
  {
    path: PAY_FORM_EDIT,
    component: <ReglementForm />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: RETOUR_PAGE,
    component: <RetourClientList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: RETOUR_FORM_NEW,
    component: <CustomerReturnForm />,
    roles: [ROLE_CAISSE, ROLE_ADMIN],
  },
  {
    path: RETOUR_FORM_EDIT,
    component: <CustomerReturnForm />,
    roles: [ROLE_CAISSE, ROLE_ADMIN],
  },

  // Module System Routes
  {
    path: MODULES_PAGE,
    component: <ModuleSelector />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER, ROLE_SUPER_ADMIN],
  },
  {
    path: DASHBOARD_MODULE_PAGE,
    component: <DashboardModule />,
    roles: [ROLE_SUPER_ADMIN],
  },
  {
    path: INVENTORY_MODULE_PAGE,
    component: <InventoryModule />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: POS_MODULE_PAGE,
    component: <POSModule />,
    roles: [ROLE_ADMIN],
  },
  {
    path: SHIFT_MODULE_PAGE,
    component: <ShiftModule />,
    roles: [ROLE_ADMIN],
  },
  {
    path: PROMOTION_MODULE_PAGE,
    component: <PromotionModule />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER],
  },
 
  {
    path: SALES_MODULE_PAGE,
    component: <SalesModule />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: PURCHASES_MODULE_PAGE,
    component: <PurchasesModule />,
    roles: [ROLE_ADMIN],
  },
  {
    path: FINANCE_MODULE_PAGE,
    component: <FinanceModule />,
    roles: [ROLE_ADMIN],
  },
  {
    path: ACCOUNTING_MODULE_PAGE,
    component: <AccountingModule />,
    roles: [ROLE_ADMIN],
  },
  {
    path: REPORTS_MODULE_PAGE,
    component: <ReportsModule />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: SETTINGS_MODULE_PAGE,
    component: <SettingsModule />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER, ROLE_SUPER_ADMIN],
  },
  {
    path: WOOCOMMERCE_MODULE_PAGE,
    component: <WooCommerceModule />,
    roles: [ROLE_ADMIN, ROLE_SUPER_ADMIN],
  },
  {
    path: ZAKAT_MODULE_PAGE,
    component: <ZakatModule />,
    roles: [ROLE_SUPER_ADMIN],
  },

  // Legacy Routes (keep for backward compatibility)
  {
    path: SALES_PAGE,
    component: <SaleForm />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: PROFILE_PAGE,
    component: <ProfilePage />,
    roles: [ROLE_CAISSE, ROLE_ADMIN, ROLE_MANAGER, ROLE_SUPER_ADMIN],
  },
  {
    path: SUPPLIER_PAYMENTS_PAGE,
    component: <SupplierPaimentsList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: CUSTOMER_PAYMENTS_PAGE,
    component: <ClientPaimentsList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: SALES_REPORT_PAGE,
    component: <VentesStatistiques />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  

 
  {
    path: INVENTORY_PAGE,
    component: <InventoryListPage />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: PRODUCTS_PAGE,
    component: <ProductList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: PRODUCTS_FORM_PAGE,
    component: <ProductForm />,
    roles: [ROLE_ADMIN, ROLE_AGENT, ROLE_CAISSE],
  },

  {
    path: CPMT_PRODUCTS_FORM_NEW,
    component: <CFormulaireArticle />,
    roles: [ROLE_ADMIN, ROLE_AGENT, ROLE_CAISSE],
  },

  {
    path: CPMT_PRODUCTS_FORM_EDIT,
    component: <CFormulaireArticle />,
    roles: [ROLE_ADMIN, ROLE_AGENT, ROLE_CAISSE],
  },

  {
    path: CATEGORY_PAGE,
    component: <CategorieList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },

  {
    path: UM_PAGE,
    component: <UnitesList />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },

  {
    path: ENTREPOT_PAGE,
    component: <EntrepotPage />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },

  {
    path: DASHBOARD_MODULE_PAGE,
    component: <Dashboard />,
    roles: [ROLE_SUPER_ADMIN],
  },
  {
    path: CLIENT_FORM_PAGE,
    component: <ClientForm />,
    roles: [ROLE_ADMIN],
  },
  {
    path: CLIENT_EDIT_PAGE,
    component: <ClientForm />,
    roles: [ROLE_ADMIN],
  },
  {
    path: CLIENT_PAGE,
    component: <ClientList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: DEVIS_PAGE,
    component: <DevisList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: COMMANDE_PAGE,
    component: <BonCommandeList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: BARCODE_PAGE,
    component: <BarcodePage />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: STOCK_PAGE,
    component: <StockPage />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: INVOICE_PAGE,
    component: <InvoiceList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: CUSTOMER_RETURNS_PAGE,
    component: <CustomerReturnsList/>,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
   {
    path: CUSTOMER_RETURN_FORM_PAGE,
    component: <CustomerReturnForm />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: CUSTOMER_RETURN_DETAIL_PAGE,
    component: <CustomerReturnDetail  />,
    roles: [ROLE_CAISSE, ROLE_ADMIN,ROLE_MANAGER],
  },
  {
    path: SUPPLIER_INVOICE_PAGE,
    component: <SupplierInvoiceList />,
    roles: [ROLE_ADMIN],

  },
  {
    path: PURCHASE_PAGE,
    component: <PurchasePage />,
    roles: [ROLE_ADMIN],
  },

  {
    path: SUPPLIER_PAGE,
    component: <SupplierInvoiceSummary />,
    roles: [ROLE_ADMIN],
  },
  {
    path: CLIENT_PAGE,
    component: <ClientList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: PURCHASE_ORDERS_PAGE,
    component: <BuyForm />,
    roles: [ROLE_ADMIN],
  },
  {
    path: BUYS_HISTORY_PAGE,
    component: <BuysReport />,
    roles: [ROLE_ADMIN],
  },
  {
    path: DELIVERY_NOTE_PAGE,
    component: <DeliveryList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: RECEPTION_PAGE,
    component: <ReceptionPage />,
    roles: [ROLE_ADMIN],
  },
  {
    path: REGLEMENTS_PAGE,
    component: <ReglementsList />,
    roles: [ROLE_ADMIN],
  },
  {
    path: NEW_INVOICE_PAGE,
    component: <NewInvoicePage />,
    roles: [ROLE_ADMIN],
  },
  {
    path: REGLEMENTS_REPORT_PAGE,
    component: <ReglementReport />,
    roles: [ROLE_ADMIN],
  },

  {
    path: CHECK_MANAGEMENT_PAGE,
    component: <DashboardEncaissements />,
    roles: [ROLE_ADMIN],
  },

  // Comptabilité routes
  {
    path: RELEVE_COMPTE_PAGE,
    component: <ReleveCompte />,
    roles: [ROLE_ADMIN],
  },
  {
    path: BALANCE_COMPTABLE_PAGE,
    component: <BalanceComptable />,
    roles: [ROLE_ADMIN],
  },
  {
    path: GRAND_LIVRE_PAGE,
    component: <GrandLivre />,
    roles: [ROLE_ADMIN],
  },
  {
    path: SYNTHESE_COMPTABLE_PAGE,
    component: <SyntheseComptable />,
    roles: [ROLE_ADMIN],
  }

];

const publicRoutes = [
  { path: "/", exact: true, component: <LoginForm /> },
  { path: LOGIN_PAGE, component: <LoginForm /> },
];

export { authProtectedRoutes, publicRoutes };
